import React, { useContext, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Menu from "src/components/common/Menu";
import { MenuContext } from "src/context/MenuContext";
import { CopyContext } from "src/context/CopyContext";
import Header from "src/components/common/Header";
import { useForm } from "react-hook-form";
import ProjectCostValidataionSchema from "src/validation/ProjectCostValidationSchema";
import { yupResolver } from "@hookform/resolvers/yup";
import { ValidationMessages } from 'src/components/common/ValidationMessage';
import ScrollTop from 'src/components/common/ScrollTop';
import DoughnutChart from "src/components/common/DoughnutChart";
import { useDispatch, useSelector } from "react-redux";
import { addProjectCost } from "src/store/projectcost";
import { getSingleProjects, resetSingleProject } from "src/store/project";

const ProjectDetails = () => {

    const { id } = useParams();
    const [isPopupVisible, setPopupVisible] = useState(false);
    const [validationMessages, setValidationMessages] = useState([])
    const [value, setValue] = useState([]);

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const projectData = useSelector((state) => state.project.singleData);
    const [costValue, setCostValue] = useState(projectData?.total_cost || 0);

    useEffect(() => {
        if (projectData?.total_cost) {
            setCostValue(projectData.total_cost);
        }
    }, [projectData.total_cost]);

    const {
        register,
        handleSubmit,
        formState: { errors },
        reset,
    } = useForm({
        resolver: yupResolver(ProjectCostValidataionSchema),
        mode: 'onSubmit',
    });

    useEffect(() => {
        const messagesArray = Object.values(errors).map((error) => error.message);
        setValidationMessages(messagesArray);
    }, [errors]);

    useEffect(() => {
        dispatch(getSingleProjects(id));
    }, []);

    useEffect(() => {
        if (id) {
            setValue("id", id);
        }
    }, [id, setValue]);

    const handlePopupOpen = () => {
        reset();
        setPopupVisible(true); // Show the pop-up
    };

    const handlePopupClose = () => {
        setPopupVisible(false); // Hide the pop-up
    };

    const clickProjectListBtn = () => {
        dispatch(resetSingleProject());
        navigate("/projectList");
    };
    const { setCopyFlg } = useContext(CopyContext);
    const { order_date, billing_date, billing_plans_date, start_date, end_date, ...filteredProjectData } = projectData;
    const clickCopyBtn = () => {
        setCopyFlg(true);
        alert("You are going to duplicate the previous project. Are you sure?");
        navigate("/projectInput", { state: { formData: filteredProjectData } });
    };

    const onSubmit = (data) => {
        if (data) {
            dispatch(addProjectCost(data))
                .then((response) => {
                    if(response.payload.errors) {
                        setValidationMessages(response.payload.errors?.cost_price)
                    }
                    else {
                        alert('The cost registration has been completed.')
                        handlePopupClose();
                        reset();
                        dispatch(getSingleProjects(id));
                    }
                })
                .catch((error) => {
                    setValidationMessages(error);
                });
        }
    }

    const { visibleMenu } = useContext(MenuContext);

    return (
        <>
            <div className="project_detail">
                {visibleMenu && <Menu />}
                <div className={visibleMenu ? "menu-open" : "menu-closed"}>
                    <div className="navbar navbar-fixed-top navbar-absolute">
                        <Header sx={{ mb: 4 }} />
                    </div>
                    <section className="container-fluid contents-top">
                        <div className="menu-closed" style={{ paddingTop: "0px" }}>
                            <div className="text-right">
                                <button type="button" className="btn btn-default" onClick={clickProjectListBtn}>
                                    <span className="glyphicon glyphicon-chevron-left" aria-hidden="true"></span>Back to List
                                </button>
                            </div>
                            <div className="project_detail_wrap" style={{ width: "90%", margin: "0 auto" }}>
                                <h3 className="title-style01">Project Details</h3>
                                <div className="row">
                                    <div className="col-md-5">
                                        <p>Quick Network</p>
                                        <p className="lead"> {projectData.name} &nbsp;
                                            <a href={`/projectEdit/${id}`} className="btn btn-default">
                                                <span className="glyphicon glyphicon-pencil" aria-hidden="true" />
                                            </a>
                                            &nbsp;
                                            <button id="pj_copy_btn" className="btn btn-success" onClick={clickCopyBtn}>Copy</button>
                                        </p>
                                        <p>Period：　{projectData.start_date} ～ {projectData.end_date}</p>
                                        <p>
                                            Claim：　{" "}
                                            {projectData.billing_date ? projectData.billing_date : ''} <span className="label label-success">Completed</span>
                                        </p>
                                        <p>Completion report：</p>
                                    </div>
                                    <div className="col-md-3">
                                        <DoughnutChart orderPrize={projectData.order_price} costPrize={costValue} fontColor={"#000000"} />
                                    </div>
                                    <div className="col-md-3">
                                        <p className="lead text-right common-alignment">
                                            Order amount: <span>Rs {projectData.order_price}</span>
                                        </p>
                                        <p className="lead text-right common-alignment">
                                            Cost price: <span className="project_cost_price">{'Rs ' + costValue}</span>
                                        </p>
                                        <p className="lead text-right common-alignment">
                                            Gross profit: <span>{costValue ? projectData.order_price - costValue : 'Rs 0'}</span>
                                        </p>
                                    </div>

                                    <div className="col-md-1">
                                        <p className="mb30">　</p>
                                        <p>
                                            <button type="button" className="btn btn-green ml5 clr-green-weak jq-popup-open jq-popup-cost_register btn_cost_detail" onClick={handlePopupOpen}>
                                                <span className="glyphicon glyphicon-plus" aria-hidden="true" />
                                            </button>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
            </div>
            <div className={isPopupVisible ? "popup-area jq-popup" : ''}>
                {isPopupVisible && (
                    <div className="layout-popup">
                        <div className="popup-close jq-popup-close">
                            <span className="glyphicon glyphicon-remove" aria-hidden="true" onClick={handlePopupClose} />
                        </div>
                        <div className="title-area">Fixed cost registration</div>
                        <form id="cost_register_form" onSubmit={handleSubmit(onSubmit)}>
                            <input type="hidden" {...register("t_project_id")} defaultValue={id} />
                            {validationMessages && validationMessages.length > 0 && (
                                <div style={{ background: "#ffe4e2" }}>
                                    <ValidationMessages
                                        messages={validationMessages}
                                        onClose={() => setValidationMessages([])}
                                    />
                                </div>
                            )}
                            <div className="form-area">
                                <p>
                                    Cost name <span style={{ color: "red" }}>*</span>
                                </p>
                                <input type="text" className="form-control" {...register("cost_name")} />
                            </div>
                            <div className="form-area">
                                <p>
                                    Cost (price) [excluding tax]{" "}
                                    <span style={{ color: "red" }}>*</span>
                                </p>
                                <input type="number" className="form-control" {...register("cost_price")} />
                            </div>
                            <div className="form-area">
                                <p>Remarks</p>
                                <textarea {...register("remarks")} className="form-control" rows={3} style={{ minHeight: 150, width: 650 }} />
                            </div>
                            <div className="btn-area">
                                <button type="submit" className="btn btn-success btn-block jq-regist_cost_price" >Registrer</button>
                                <button type="button" className="btn btn-default btn-block jq-delete_cost_price" hidden style={{ display: "none" }}>Delete</button>
                            </div>
                        </form>
                    </div>
                )}
            </div>
            <ScrollTop />
        </>

    );
};

export default ProjectDetails;
